import React from "react";

export const AlertIcon = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="32" fill="#FFE3E0" />
      <circle cx="32" cy="32" r="24" fill="#FFC6C2" />
      <path
        d="M32 33.2L32 27.2M32.0064 38L31.9957 38M32 20C25.4 20 20 25.4 20 32C20 38.6 25.4 44 32 44C38.6 44 44 38.6 44 32C44 25.4 38.6 20 32 20Z"
        stroke="#CA0E00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
